import React from "react";
import "./style.css";

function Footer({ className }) {
    return (
        <footer className={className}>
            &copy; Billy Hao
        </footer>
    )
}

export default Footer;